var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5618 2.19971L12.0935 7.74659L13.4745 4.47401L19.5618 2.19971Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32077 2.19971L9.72914 7.79914L8.41558 4.47401L2.32077 2.19971Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8748 15.0576L14.8858 18.1051L19.1417 19.276L20.3651 15.1252L16.8748 15.0576Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53256 15.1252L2.74852 19.276L7.00437 18.1051L5.01531 15.0576L1.53256 15.1252Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76428 9.90868L5.57834 11.7026L9.80413 11.8902L9.65407 7.34912L6.76428 9.90868Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1183 9.90897L12.191 7.29688L12.0935 11.8905L16.3118 11.7029L15.1183 9.90897Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00436 18.1051L9.54141 16.8666L7.34964 15.1553L7.00436 18.1051Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3412 16.8666L14.8857 18.1051L14.5329 15.1553L12.3412 16.8666Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8857 18.1052L12.3412 16.8667L12.5438 18.5255L12.5214 19.2236L14.8857 18.1052Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00436 18.1052L9.36871 19.2236L9.35368 18.5255L9.54141 16.8667L7.00436 18.1052Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40639 14.0595L7.2897 13.4364L8.78338 12.7534L9.40639 14.0595Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4762 14.0595L13.0992 12.7534L14.6003 13.4364L12.4762 14.0595Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00432 18.1051L7.36461 15.0576L5.01526 15.1252L7.00432 18.1051Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5252 15.0576L14.8855 18.1051L16.8746 15.1252L14.5252 15.0576Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3115 11.7026L12.0932 11.8903L12.4835 14.0595L13.1065 12.7534L14.6077 13.4365L16.3115 11.7026Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28944 13.4365L8.79063 12.7534L9.40609 14.0595L9.80392 11.8903L5.57809 11.7026L7.28944 13.4365Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57834 11.7026L7.34973 15.1554L7.28969 13.4365L5.57834 11.7026Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6081 13.4365L14.533 15.1554L16.312 11.7026L14.6081 13.4365Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80417 11.8901L9.40634 14.0593L9.90171 16.6189L10.0143 13.2486L9.80417 11.8901Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0934 11.8901L11.8907 13.2412L11.9807 16.6189L12.4837 14.0593L12.0934 11.8901Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.484 14.0595L11.9811 16.619L12.3414 16.8667L14.5331 15.1554L14.6082 13.4365L12.484 14.0595Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2897 13.4365L7.34975 15.1554L9.5415 16.8667L9.90175 16.619L9.40639 14.0595L7.2897 13.4365Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5212 19.2234L12.5438 18.5254L12.3561 18.3602H9.52638L9.35368 18.5254L9.36871 19.2234L7.00436 18.105L7.83001 18.7806L9.50383 19.9439H12.3786L14.0599 18.7806L14.8856 18.105L12.5212 19.2234Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3411 16.8663L11.9808 16.6187H9.90165L9.5414 16.8663L9.35376 18.5251L9.52637 18.36H12.3561L12.5438 18.5251L12.3411 16.8663Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8772 8.10688L20.5152 5.04446L19.5619 2.19971L12.3412 7.55895L15.1184 9.90833L19.044 11.0567L19.9147 10.0434L19.5394 9.77322L20.1399 9.22523L19.6745 8.86498L20.2749 8.40712L19.8772 8.10688Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 5.04446L2.013 8.10688L1.60769 8.40712L2.20816 8.86498L1.75029 9.22523L2.35077 9.77322L1.97547 10.0434L2.83865 11.0567L6.76425 9.90833L9.5414 7.55895L2.32074 2.19971L1.375 5.04446Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0439 11.0571L15.1183 9.90869L16.3117 11.7026L14.5328 15.1553L16.8746 15.1253H20.3649L19.0439 11.0571Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76418 9.90869L2.83858 11.0571L1.53256 15.1253H5.01531L7.34965 15.1553L5.57825 11.7026L6.76418 9.90869Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0933 11.89L12.341 7.55906L13.4819 4.47412H8.41537L9.5413 7.55906L9.80401 11.89L9.89403 13.256L9.90155 16.6187H11.9807L11.9957 13.256L12.0933 11.89Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0750593,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.996bd4618b667ff8971771007c917cb0.svg";
export { ForwardRef as ReactComponent };